const HeaderLogo = () => {
  return (
    <div className="login-img11">
      <img
        className="swallow-logo-login header"
        src="/assets/images/logo-swallow.jpg"
        alt=""
      />
    </div>
  );
};
export default HeaderLogo;
